import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// Higher-order component to protect admin routes
const ProtectedRoute = ({ children }) => {
  const navigate = useNavigate();
  const isLoggedIn = sessionStorage.getItem('adminLoggedIn') === 'true';

  useEffect(() => {
    if (!isLoggedIn) {
      navigate('/admin');
    }
  }, [isLoggedIn, navigate]);

  if (!isLoggedIn) {
    return (
      <div className="min-h-screen bg-slate-900 flex items-center justify-center">
        <div className="w-8 h-8 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

  return children;
};

export default ProtectedRoute;
